const POINT_COUNT = 5;

const POINT_TYPES = ['taxi','bus','train','ship','drive','flight','check-in','sightseeing','restaurant'];

export {POINT_COUNT, POINT_TYPES};
